module.exports = __webpack_public_path__ + "img/aboutUsBg.74bd6628.png";